import dayjs, { Dayjs } from 'dayjs';

export type TimeDifference = {
  seconds: number;
  minutes: number;
  hours: number;
  days: number;
};

export default function getTimeDifference(date: Dayjs): TimeDifference {
  const currentDate = dayjs();
  if (currentDate.isAfter(date)) {
    return {
      seconds: 0,
      minutes: 0,
      hours: 0,
      days: 0
    };
  }
  const diff = date.diff(currentDate);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return {
    seconds,
    minutes,
    hours,
    days
  };
}
